// @internal
import styled from 'styled-components';
import { OutlineStyles, ResetButton } from '../../styles';
import { sidenavTokens } from '../../../../tokens/components/SideNav/tokens';

export const StyledSideNavToggle = styled.button`
  ${ResetButton}

  border-radius: ${sidenavTokens.ToggleBorderRadiusBaseDefault};
  color: ${sidenavTokens.FontColorBaseDefault};
  cursor: pointer;
  line-height: 20px;
  padding: ${sidenavTokens.TogglePaddingBaseDefaultVertical} ${sidenavTokens.TogglePaddingBaseDefaultHorizontal};

  ${OutlineStyles}

  &:hover {
    background-color: ${sidenavTokens.GroupToggleBackgroundColorBaseHover};
    color: ${sidenavTokens.FontColorBaseDefault};
  }
`;
